import React from "react";
import {Outlet} from "react-router-dom";
import BillingNavTab from "./BillingNavTab";

function Billing() {
    return (
        <section className="section-bg-color setting_tab px-2"
                  style={{minHeight: "calc(100vh - 100px)", overflowX: 'hidden', marginTop:"7vh"}}>
            <div className="custom_container ">
                <div className="row">

                    <BillingNavTab/>

                    <div className="col-lg-10 col-md-9">
                        <div className="tab-content px-lg-3 bg_transparent" id="nav-tabContent"
                             style={{minHeight: 'calc(100vh - 259px)', marginBottom: '30px'}}>

                            <Outlet/>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Billing;